import { useTranslation } from "react-i18next";


interface ElectionsActiveBannerProps {
  electionEndAt: string | null | undefined;
  formatElectionTimeRemaining: (electionEndAt: string | null | undefined) => string;
  marginTop?: string;
}

export default function ElectionsActiveBanner({
  electionEndAt,
  formatElectionTimeRemaining,
  marginTop = "16px",
}: ElectionsActiveBannerProps) {
  const { t } = useTranslation();

  if (!electionEndAt) return null;

  return (
    <div
      className="box-border w-full rounded-lg border-2 border-success bg-success-alpha-10 px-lg py-md"
      style={{
        marginTop,
      }}
    >
      <div
        className="mb-xs w-full [font-family:'Lato',sans-serif] text-[12px] leading-[20px] font-bold text-success"
      >
        {t("Elections are currently taking place!")}
      </div>
      <div
        className="mb-xs [font-family:'Lato',sans-serif] text-[10px] leading-[16px] font-normal text-success-text"
      >
        {t("Time remaining until election end:")}
      </div>
      <div
        className="mb-xs [font-family:'Lato',sans-serif] text-[10px] leading-[16px] font-normal text-success-text"
      >
        {formatElectionTimeRemaining(electionEndAt)}
      </div>
      <div
        className="[font-family:'Lato',sans-serif] text-[10px] leading-[16px] font-normal text-success-text"
      >
        {t("You can also vote or register for mayor elections, for this choose the appropriate option in the menu below!")}
      </div>
    </div>
  );
}
